import type { AvatarTone } from '@/types/domain';

const TONES: Record<AvatarTone, [string, string]> = {
  sage: ['#e7ebe2', '#44513f'],
  ochre: ['#f0e8d8', '#856024'],
  clay: ['#efe2db', '#7e4536'],
  slate: ['#e3e8ec', '#3f4d59'],
};

export interface AvatarProps {
  initials: string;
  size?: number;
  tone?: AvatarTone;
  photoUrl?: string;
  alt?: string;
}

/** Initials avatar (or a real photo when available). */
export function Avatar({ initials, size = 38, tone = 'sage', photoUrl, alt }: AvatarProps) {
  const [bg, fg] = TONES[tone] ?? TONES.sage;
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={alt ?? initials}
        width={size}
        height={size}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flex: 'none' }}
      />
    );
  }
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        color: fg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        fontSize: size * 0.4,
        fontWeight: 600,
        letterSpacing: '.02em',
      }}
    >
      {initials}
    </div>
  );
}
